const HeaderRequest = () => {
  const header = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  return header;
};
const HeaderRequestFull = () => {
  const header = {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  };
  return header;
};

export { HeaderRequest, HeaderRequestFull };
